var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-theme-provider",
    {
      attrs: {
        dark: _vm.effectiveAppearance === "dark",
        light: _vm.effectiveAppearance === "light"
      }
    },
    [
      _c(
        "div",
        {
          class: [{ "mx-brand-form-surface": _vm.resolvedBranding }].concat(
            _vm.brandClasses
          ),
          style: _vm.resolvedBranding
            ? _vm.formBrandStyle(_vm.resolvedBranding)
            : null,
          attrs: { id: _vm.brandTargetId }
        },
        [
          _c(
            "div",
            { staticClass: "mx-brand-form" },
            _vm._l(_vm.schema, function(item, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isItemVisible(item),
                      expression: "isItemVisible(item)"
                    }
                  ],
                  key: item.id,
                  attrs: { id: item.id }
                },
                [
                  _c("item-renderer", {
                    ref: "item",
                    refInFor: true,
                    attrs: {
                      index: index + 2 * 1000,
                      item: item,
                      styles: _vm.styles,
                      disabled: false,
                      "account-logo": _vm.accountLogo,
                      active: false,
                      results: _vm.results
                    },
                    on: {
                      input: function($event) {
                        return _vm.handleInput($event)
                      }
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }